module.exports = __webpack_public_path__ + "img/writingSeminar_041022_B.e31aea05.jpg";